<!--
 * @Description: 
 * @Author: xgx
 * @Date: 2022-09-30 15:51:57
 * @LastEditors: xgx
 * @LastEditTime: 2022-09-30 15:51:57
-->
<template>
   <div>书记信箱</div>
</template>

<script>
export default {

}
</script>

<style>

</style>